import React, { Component } from 'react';

import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';

import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';

import * as api from '../../api/api';
import ReactGA from 'react-ga';

class MySubmission extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      open: false,
      initialApiLoading: false,
      data:{
        'paidReg': []
      },

    };

    this.handleuploadClick = this.handleuploadClick.bind(this)
  }

  componentDidMount() {
    ReactGA.set({ userId: this.props.user.id });
    ReactGA.initialize('UA-139837993-1');
    ReactGA.pageview('/my_submission');
    let data = Object.assign({}, this.state.data)
    return api.getPaidRegistrations(this.props.user.accessToken)
      .then((result) => {
        
        data.paidReg = result.data
        this.setState({data: data, initialApiLoading:true})
    })
  }

  handleuploadClick(evt, certParticipationId, type, fullCertId, mcCertTopicId, topicName, tqCertDetailId){
      this.props.clickUpload(certParticipationId, type, fullCertId, mcCertTopicId, topicName, tqCertDetailId)
  };

  render() {
    let table_body
   
    let handleuploadClick = this.handleuploadClick
    if(this.state.data.paidReg.length>0){
       table_body = <table>
                      <th> Cycle Start </th>
                      <th> Cycle end</th>
                      <th> Type </th>
                      <th> Certification Level </th>
                      <th> Track </th>
                      <th> Submission </th>
                      <th> Guideline </th>
                      <tbody>
                        {this.state.data.paidReg.map(function(reg) {
                           
                           reg.submissionStart = reg.submissionStart.split('T')[0]
                           reg.submissionEnd = reg.submissionEnd.split('T')[0]
                           let certTypeToShow  
                          if(reg.certificationType =='FC')
                            certTypeToShow = 'CENTA Certification'
                          else if(reg.certificationType =='MC')
                            certTypeToShow = 'Micro-Credentials - ' + reg.topicName
                          else if(reg.certificationType =='TQ')
                            certTypeToShow = 'Teaching Quotient'
                          
                          return (
                            <tr>
                              <td>{reg.submissionStart}</td>
                              <td>{reg.submissionEnd}</td>
                              <td>{certTypeToShow}</td>
                              <td>{reg.level}</td>
                              <td>{reg.track}</td>
                              <td><Button onClick={((e) => handleuploadClick(e, reg.certificationParticipationId, reg.certificationType, reg.fullCertId, reg.mcCertTopicId, reg.topicName, reg.tqCertDetailId))}>Upload</Button></td>
                              <td><a href={reg.guideline} target="_blank">Guideline</a></td>
                              
                            </tr>
                          )
                        })}


                      </tbody>

                    </table>
    }

    else{
      if(this.state.initialApiLoading){
        table_body = (
            <div>
               <Typography use="subtitle">This is the space to upload your submissions towards CENTA Micro-Credentials and CENTA Teaching Quotient (TQ). The Submission portal is not activated for you yet. You can access this space after you successfully register for either of CENTA Certification/Micro-Credentials or CENTA Teaching Quotient (TQ).</Typography>
            </div>
          )
      }
      else{
        table_body = (
          <div className="loader-component">
            <div className="loader"></div>
            <h4> Loading. Please wait..</h4>
          </div>
        )
      }
    }

    return (
      <div class="mdc-layout-grid">

        <div class="mdc-layout-grid__inner">
          <div class="mdc-layout-grid__cell--span-10">
          
            <Typography use="headline5">My Submissions</Typography>
           
            <div>
            <div>
               <Typography style={{fontSize: '12px'}}>You are requested to verify the successful upload of your submission. You can do this by clicking on the "View Submission" button (visible after making the upload) to ensure that the file is correctly uploaded. In case of any issues, WhatsApp us on +91 73496 62401.</Typography>
            </div>
              <br/>
              {table_body}
              <br/>

            </div>


          <div class="mdc-layout-grid__cell--span-1"></div>
          <div class="mdc-layout-grid__cell--span-1"></div>
        </div>
      </div>
    </div>
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MySubmission);



// WEBPACK FOOTER //
// ./src/views/submissions/MySubmission.jsx